import React, { useEffect, useState } from 'react'
import { isAuthenticated } from '../services/authService';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import ShellV2 from '../v2/shell/ShellV2';
import { useUiVersion } from '../UiVersionContext';

// The only place the two shells diverge.
//
// The new shell gives every screen its own path (v2/shell/nav.js SCREEN_PATHS) and App.js
// routes all of them here. MfaGate gates every path that is not on its exclusion list, so
// those paths are covered without being listed there — nav.js explains the one rule
// their spelling has to follow.
//
// The old shell still lives at /dashboard alone and picks its screen from ?tab=. Someone
// on it who follows a new-style link (or switches back to it from a deep screen) is sent
// to /dashboard rather than shown a page it has no idea how to read.
function LDashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { uiVersion } = useUiVersion();

  useEffect(() => {
    const verifyAuth = async () => {
      const authStatus = await isAuthenticated();
      if (!authStatus) {
        navigate('/login');
      } else {
        setLoading(false);
      }
    };

    verifyAuth();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  if (uiVersion !== 'v2' && location.pathname !== '/dashboard') {
    return <Navigate to="/dashboard" replace />;
  }

  return uiVersion === 'v2' ? <ShellV2 /> : (
    <div>
      <Dashboard />
    </div>
  );
}

export default LDashboard
